import { lazy } from 'react';
import RedireccionarMenu from '../utils/RedireccionarMenu';

const Ganador = lazy(() => import('../ruleta/Ganador'));
const Ruleta = lazy(() => import('../ruleta/Ruleta'));
const RuletaColaboradores = lazy(() => import('../ruleta/RuletaColaboradores'));
const GanadorColaborador = lazy(() => import('../ruleta/GanadorColaborador'));
const Login = lazy(() => import('../ruleta/Login'));

const rutas = [
  // pública
  { path: '/login', componente: Login, exact: true, privado: false },

  // privadas
  { path: '/ganador/:username', componente: Ganador, exact: true, privado: true },
  { path: '/colaboradores', componente: RuletaColaboradores, exact: true, privado: true },
  { path: '/ganador/colaborador/:username', componente: GanadorColaborador, exact: true, privado: true },
  { path: '/', componente: Ruleta, exact: true, privado: true },

  // fallback
  { path: '*', componente: RedireccionarMenu, privado: false }
];

export default rutas;
